import { defaultOtrosTlv } from "./state";

/**
 * Mutación que carga la información de otros tlv de un producto químico.
 * 
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} dataTlv contiene la información de otros tlv.
 */
export function setOtrosTlv(state, dataTlv){
    state.dataTlv = dataTlv.data;
    state.filtro.total = dataTlv.total; 
}

/**
 * Mutación para editar la información de otros tlv de una sustancia
 * 
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene la información de la sustancia.
 */
export function setSelectedOtrosTlv(state, data) {
    Object.assign(state.selectedOtrosTlv, data);
}

/**
 * Mutación para limpiar el formulario de otros tlv
 * 
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiarSelectedOtrosTlv(state) {
    Object.assign(state.selectedOtrosTlv, defaultOtrosTlv());
}

/**
 * Mutación para cambiar de página
 * 
 * @param {*} state contiene la información de las variables del formulario.
 */
 export function setPage(state, page) {
    state.filtro.page = page;
}

/**
 * Mutación para cambiar registros por página
 * 
 * @param {*} state contiene la información de las variables del formulario.
 */
export function setPerPage(state, perPage) {
    state.filtro.perPage = perPage;
}